
export const useQRCode = () => {
  const download = () => {
    const qrCodeImageElement = document.getElementById('qr-code-download') as HTMLImageElement

    if (qrCodeImageElement) {
      const imageName = 'menon-qr-code.png'

      const link = document.createElement('a')
      link.href = qrCodeImageElement.src
      link.download = imageName
      link.click()
      link.remove()
    }
  }

  return { download }
}
